<template>
    <base-auth>
        <div v-if="error_message != ''">
            <div class="alert alert-danger text-white fade show mx-auto w-75">
                <span v-html="error_message"></span>
            </div>
        </div>
        <template v-slot:tabs>
            <div v-if="!has_two_factor_auth">
                <div class="auth-tabs-switch" role="tablist">
                    <router-link to="/login" class="auth-tab"
                        >ورود</router-link
                    >
                    <router-link to="/register" class="auth-tab"
                        >ثبت‌نام</router-link
                    >
                </div>
            </div>
        </template>
        <form v-if="!has_two_factor_auth" @submit.prevent="executeCaptcha">
            <div class="card-login-register w-75 pt-2 pb-3">
                <vue-recaptcha
                    v-if="captchaDriver === 'recaptcha'"
                    ref="invisibleRecaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                    size="invisible"
                    :sitekey="sitekey"
                    :loadRecaptchaScript="true"
                >
                </vue-recaptcha>
                <arcaptcha-vue
                    v-if="captchaDriver === 'arcaptcha' && !has_two_factor_auth"
                    ref="arcaptcha"
                    key="login-captcha"
                    :site_key="arCaptchaKey"
                    :invisible="true"
                    :callback="onArcaptchaSuccess"
                    :expired_callback="onArcaptchaExpired"
                    :error_callback="onArcaptchaError"
                    :loadRecaptchaScript="true"
                />
                <div class="login-form">
                    <div class="form-field mt-5" style="direction: rtl">
                        <input
                            v-bind:placeholder="
                                $t('auth.placeholder.outh_param')
                            "
                            name="outh_param"
                            autocomplete="off"
                            v-model="outh_param"
                            type="text"
                        />
                    </div>
                    <div class="form-field mt-3" style="direction: rtl">
                        <div
                            id="password_eye"
                            @click="is_password_shown = !is_password_shown"
                        >
                            <span v-if="is_password_shown">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    width="20"
                                    fill="#888"
                                >
                                    <path
                                        d="M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                                        fill="none"
                                    />
                                    <path
                                        d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"
                                    />
                                </svg>
                            </span>
                            <span v-else>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    width="20"
                                    fill="#888"
                                >
                                    <path d="M0 0h24v24H0V0z" fill="none" />
                                    <path
                                        d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
                                    />
                                </svg>
                            </span>
                        </div>
                        <input
                            :type="is_password_shown ? 'text' : 'password'"
                            id="password"
                            v-bind:placeholder="$t('auth.placeholder.pass')"
                            name="password"
                            direction="ltr"
                            autocomplete="off"
                            v-model="password"
                        />
                    </div>
                    <div class="form-link mt-3" style="width: auto">
                        <div class="mb-4" style="width: auto">
                            <kt-form-check
                                id="remember"
                                name="remember"
                                v-model="remember"
                            >
                            </kt-form-check>
                            <label class="px-2" for="remember">{{
                                $t('auth.remember_me')
                            }}</label>
                        </div>
                    </div>
                    <div class="login-footer">
                        <button v-if="is_login_pending" type="button" disabled>
                            <div
                                class="d-flex justify-content-center align-items-center"
                            >
                                <div class="px-2">در حال ورود</div>
                                <div
                                    class="spinner-border spinner-border-sm text-white"
                                    role="status"
                                ></div>
                            </div>
                        </button>
                        <input
                            v-else
                            type="submit"
                            :value="$t('auth.btn.sign_in')"
                        />
                        <div class="mt-3">
                            <router-link
                                id="kt_login_forgot"
                                to="/forget-pass"
                                class="text-success"
                            >
                                {{ $t('auth.forget_pass') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div v-if="has_two_factor_auth" class="my-5">
            <div class="card-login-register w-75 pt-2 pb-3">
                <div class="login-form">
                    <form
                        id="sms-verification-form"
                        v-if="two_factor_type === TwoFactorType.SMS"
                        @submit.prevent="onSubmitVerify"
                    >
                        <vue-recaptcha
                            v-if="captchaDriver === 'recaptcha'"
                            ref="invisibleRecaptchaVerify"
                            @verify="onVerifyForAuth"
                            @expired="onExpiredVerify"
                            size="invisible"
                            :sitekey="sitekey"
                            :loadRecaptchaScript="true"
                        >
                        </vue-recaptcha>
                        <arcaptcha-vue
                            v-if="
                                captchaDriver === 'arcaptcha' &&
                                has_two_factor_auth &&
                                two_factor_type === TwoFactorType.SMS
                            "
                            ref="arcaptchaVerify"
                            key="verify-captcha"
                            :site_key="arCaptchaKey"
                            :invisible="true"
                            :callback="onArcaptchaVerifySuccess"
                            :expired_callback="onArcaptchaVerifyExpired"
                            :error_callback="onArcaptchaVerifyError"
                        />

                        <div class="form-field mt-5" style="direction: rtl">
                            <input
                                v-bind:placeholder="$t('label.phone')"
                                name="phone"
                                autocomplete="off"
                                disabled
                                :value="phone"
                                type="text"
                                id="phone"
                            />
                        </div>

                        <div class="form-field mt-3" style="direction: rtl">
                            <input
                                v-bind:placeholder="
                                    $t('auth.login.verify_label')
                                "
                                name="verify_code"
                                autocomplete="one-time-code"
                                inputmode="numeric"
                                v-model="verify_code"
                                type="text"
                            />
                        </div>

                        <div class="login-footer">
                            <button
                                v-if="is_login_pending"
                                type="button"
                                disabled
                            >
                                <div
                                    class="d-flex justify-content-center align-items-center"
                                >
                                    <div class="px-2">در حال ورود</div>
                                    <div
                                        class="spinner-border spinner-border-sm text-white"
                                        role="status"
                                    ></div>
                                </div>
                            </button>
                            <input
                                v-else
                                type="submit"
                                :value="$t('auth.btn.sign_in')"
                            />

                            <div
                                class="kt-login__account"
                                v-if="counter == false"
                            >
                                <span class="kt-login__account-msg">
                                    {{ $t('auth.not_recived') }} </span
                                >&nbsp;&nbsp;
                                <button
                                    class="btn btn-link p-0 m-0"
                                    id="resend_btn"
                                    @click="sendVerify"
                                >
                                    {{ $t('auth.btn.resend') }}
                                </button>
                            </div>
                            <div
                                class="kt-login__account"
                                v-if="counter == true"
                            >
                                <span class="kt-login__account-msg">
                                    <span class="bg-white p-0 m-0">
                                        {{ $t('auth.code_not_received') }}
                                    </span>
                                    {{ message2 }}
                                </span>
                            </div>
                            <div class="my-3">
                                <button
                                    class="btn btn-link p-0 m-0"
                                    v-if="is_g2fa_active"
                                    id="resend_btn"
                                    @click.prevent="verifyWithG2fa"
                                >
                                    {{
                                        $t(
                                            'auth.btn.login_with_google_two_factor'
                                        )
                                    }}
                                </button>
                            </div>
                        </div>
                    </form>

                    <div class="kt-login__actions"></div>

                    <div
                        class="login-form"
                        v-if="
                            two_factor_type ===
                            TwoFactorType.GOOGLE_AUTHENTICATOR
                        "
                    >
                        <form
                            id="g2fa-form"
                            class="form-field mt-3"
                            style="direction: rtl"
                            @submit.prevent="onSubmitVerifyG2fa"
                        >
                            <vue-recaptcha
                                v-if="captchaDriver === 'recaptcha'"
                                ref="invisibleRecaptchaVerifyG2fa"
                                @verify="onVerifyForG2fa"
                                @expired="onExpiredVerifyG2fa"
                                size="invisible"
                                :sitekey="sitekey"
                                :loadRecaptchaScript="true"
                            >
                            </vue-recaptcha>
                            <arcaptcha-vue
                                v-if="
                                    captchaDriver === 'arcaptcha' &&
                                    has_two_factor_auth &&
                                    two_factor_type ===
                                        TwoFactorType.GOOGLE_AUTHENTICATOR
                                "
                                ref="arcaptchaVerifyG2fa"
                                key="g2fa-captcha"
                                :site_key="arCaptchaKey"
                                :invisible="true"
                                :callback="onArcaptchaG2faSuccess"
                                :expired_callback="onArcaptchaG2faExpired"
                                :error_callback="onArcaptchaG2faError"
                                :loadRecaptchaScript="true"
                            />
                            <kt-form-control
                                v-bind:placeholder="
                                    $t('auth.login.google_authenticator_code')
                                "
                                name="google_authenticator_code"
                                class="text-center"
                                autocomplete="off"
                                v-model="google_authenticator_code"
                                type="text"
                                id="google_authenticator_code"
                                dir="ltr"
                            />

                            <div class="login-footer">
                                <button
                                    v-if="is_login_pending"
                                    type="button"
                                    id="g2fa-btn"
                                    disabled
                                >
                                    <div
                                        class="d-flex justify-content-center align-items-center"
                                    >
                                        <div class="px-2">در حال ورود</div>
                                        <div
                                            class="spinner-border spinner-border-sm text-white"
                                            role="status"
                                        ></div>
                                    </div>
                                </button>
                                <input
                                    v-else
                                    type="submit"
                                    :value="$t('auth.btn.sign_in')"
                                />
                            </div>
                            <div class="my-3" v-if="counter == false">
                                <button
                                    class="btn btn-link p-0 m-0"
                                    id="resend_btn"
                                    @click="sendVerify"
                                >
                                    {{
                                        $t('auth.btn.login_with_sms_two_factor')
                                    }}
                                </button>
                            </div>

                            <div class="my-3" v-if="counter == true">
                                <span class="kt-login__account-msg">
                                    {{ message3 }}
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="login-paylane" aria-hidden="true">
            <div
                class="paylane-node paylane-node--1"
                :class="paylaneNodeClass(1)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2.5" y="6" width="19" height="13" rx="2" /><path d="M2.5 10h19" /><path d="M15.5 15.5c.9-1 1.4-1.8 1.4-3s-.5-2-1.4-3" /><path d="M17.8 16.5c1.3-1.4 2-3 2-4.5s-.7-3.1-2-4.5" />
                </svg>
            </div>
            <span class="paylane-link" :class="paylaneLinkClass(1)"
                ><i class="paylane-dot"></i
            ></span>
            <div
                class="paylane-node paylane-node--2"
                :class="paylaneNodeClass(2)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 8h14l-3.5-3.5" /><path d="M20 16H6l3.5 3.5" />
                </svg>
            </div>
            <span class="paylane-link" :class="paylaneLinkClass(2)"
                ><i class="paylane-dot"></i
            ></span>
            <div
                class="paylane-node paylane-node--3"
                :class="paylaneNodeClass(3)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="7" y="2.5" width="10" height="19" rx="2" /><path d="M10 11.5l2 2 3.5-3.5" />
                </svg>
            </div>
            <span class="paylane-link" :class="paylaneLinkClass(3)"
                ><i class="paylane-dot"></i
            ></span>
            <div
                class="paylane-node paylane-node--4"
                :class="paylaneNodeClass(4)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 10l9-6 9 6" /><path d="M5.5 10.5v7.5" /><path d="M10 10.5v7.5" /><path d="M14 10.5v7.5" /><path d="M18.5 10.5v7.5" /><path d="M3 20.5h18" />
                </svg>
            </div>
        </div>
    </base-auth>
</template>

<script>
import baseAuth from '@/components/base-auth';
import $ from 'jquery';
import VueRecaptcha from 'vue-recaptcha';
import { reCaptchaKeys } from '@/constants/getRecaptchaKey';
import { arCaptchaKeys } from '@/constants/getArCaptchaKey';
import { getCaptchaDriver } from '@/constants/getCaptchaDriver';
import Axios from 'axios';
import { MYPANEL_REFRENCE, PEGEN_REFRENCE } from '@/common/config';
import toastr from 'toastr';
import { KTApp } from '@/plugins/core/app';
import { TwoFactorType } from '@/constants/TwoFactorType';
import Inputmask from 'inputmask';
import ArcaptchaVue from 'arcaptcha-vue';

export default {
    computed: {
        TwoFactorType() {
            return TwoFactorType;
        },
        paylane_step() {
            if (this.login_succeeded) return 4;
            if (this.has_two_factor_auth) return 3;
            if (this.is_login_pending) return 2;
            return 1;
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: 'toast-bottom-center',
                preventDuplicates: false,
                rtl: false
            };

            return toastr;
        }
    },
    data() {
        return {
            is_password_shown: false,
            error_message: '',
            is_login_pending: false,
            remember: false,
            outh_param: '',
            password: '',
            login_event: null,
            recaptcha_verified: false,
            recaptcha_verify: false,
            g_recaptcha_response: '',
            sitekey: reCaptchaKeys,
            arCaptchaKey: arCaptchaKeys,
            captchaDriver: getCaptchaDriver,
            has_two_factor_auth: false,
            verify_code: null,
            phone: '',
            timer: 180,
            message2: '',
            message3: '',
            counter: false,
            interval: null,
            two_factor_type: null,
            is_g2fa_active: null,
            google_authenticator_code: null,
            arcaptchaToken: '',
            arcaptchaVerified: false,
            is_submitting_verify: false,
            otp_abort_controller: null,
            login_succeeded: false,
            dataTestt: ''
        };
    },
    components: {
        'base-auth': baseAuth,
        'vue-recaptcha': VueRecaptcha,
        ArcaptchaVue
    },
    methods: {
        paylaneNodeClass(n) {
            return {
                'is-active': this.paylane_step === n,
                'is-done': this.paylane_step > n,
                'is-dim': this.paylane_step < n
            };
        },
        paylaneLinkClass(n) {
            return {
                'is-done': this.paylane_step > n,
                'is-running': this.paylane_step === n,
                'is-dim': this.paylane_step < n
            };
        },
        finishLogin() {
            this.login_succeeded = true;
            setTimeout(() => window.location.replace(this.$url('')), 900);
        },
        onSubmitVerify: async function (e) {
            this.is_submitting_verify = true;
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.is_login_pending = true; // stays true until callback fires
            if (this.captchaDriver === 'arcaptcha') {
                await this.$refs.arcaptchaVerify.reset();
                await this.$refs.arcaptchaVerify.execute();
                // ← no is_login_pending = false
            } else {
                this.executeCaptchaForVerify();
                // ← no is_login_pending = false
            }
        },
        onSubmitVerifyG2fa: function (e) {
            let form = $('#g2fa-form');
            form.validate({
                ignore: '.ignore',
                rules: {
                    google_authenticator_code: {
                        required: true
                    }
                }
            });
            if (!form.valid()) {
                return;
            }

            this.executeCaptchaForG2fa();
        },
        async executeCaptcha(e) {
            this.login_event = e;
            this.is_login_pending = true;
            if (this.captchaDriver === 'recaptcha') {
                await this.$refs.invisibleRecaptcha.execute();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
                await this.$refs.arcaptcha.execute();
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                this.login(this.login_event);
            }
            this.is_login_pending = false;
        },
        executeCaptchaForVerify() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.invisibleRecaptchaVerify.execute();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptchaVerify.execute();
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                this.verify();
            }
        },
        async executeCaptchaForG2fa() {
            this.is_login_pending = true;
            if (this.captchaDriver === 'recaptcha') {
                await this.$refs.invisibleRecaptchaVerifyG2fa.execute();
            } else if (this.captchaDriver === 'arcaptcha') {
                await this.$refs.arcaptchaVerifyG2fa.execute();
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                this.verifyG2fa();
            }
        },
        onArcaptchaSuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            this.login(this.login_event);
        },
        onArcaptchaExpired() {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.is_login_pending = false;
        },
        onArcaptchaError(error) {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.is_login_pending = false;
            this.error_message =
                'Captcha verification failed. Please try again.';
        },
        onArcaptchaVerifySuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            this.verify();
        },
        onArcaptchaVerifyExpired() {
            if (this.arcaptchaTimeout) {
                clearTimeout(this.arcaptchaTimeout);
                this.arcaptchaTimeout = null;
            }
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.is_submitting_verify = false;
            this.error_message = 'Captcha expired. Please try again.';
        },
        onArcaptchaVerifyError(error) {
            if (this.arcaptchaTimeout) {
                clearTimeout(this.arcaptchaTimeout);
                this.arcaptchaTimeout = null;
            }
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.is_submitting_verify = false;
        },
        onArcaptchaG2faSuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            this.verifyG2fa();
        },
        onArcaptchaG2faExpired() {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.is_login_pending = false;
        },
        onArcaptchaG2faError(error) {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
        },
        resetCaptcha() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.invisibleRecaptcha &&
                    this.$refs.invisibleRecaptcha.reset();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptcha && this.$refs.arcaptcha.reset();
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
            }
        },
        resetCaptchaVerify() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.invisibleRecaptchaVerify &&
                    this.$refs.invisibleRecaptchaVerify.reset();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptchaVerify &&
                    this.$refs.arcaptchaVerify.reset();
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
            }
        },
        async resetCaptchaVerifyG2fa() {
            this.is_login_pending = true;
            if (this.captchaDriver === 'recaptcha') {
                (await this.$refs.invisibleRecaptchaVerifyG2fa) &&
                    this.$refs.invisibleRecaptchaVerifyG2fa.reset();
                this.is_login_pending = false;
            } else if (this.captchaDriver === 'arcaptcha') {
                (await this.$refs.arcaptchaVerifyG2fa) &&
                    this.$refs.arcaptchaVerifyG2fa.reset();
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
                this.is_login_pending = false;
            }
        },
        isCaptchaVerified() {
            if (this.captchaDriver === 'recaptcha') {
                return this.recaptcha_verified;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaVerified && this.arcaptchaToken;
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                return true;
            }
            return false;
        },
        getCaptchaResponse() {
            if (this.captchaDriver === 'recaptcha') {
                return this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaToken;
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                return '';
            }
            return '';
        },
        onVerify: function (response) {
            this.recaptcha_verified = true;
            this.g_recaptcha_response = response;
            this.login(this.login_event);
        },
        onVerifyForAuth: function (response) {
            this.recaptcha_verify = true;
            this.g_recaptcha_response = response;
            this.verify();
        },
        onVerifyForG2fa: function (response) {
            this.recaptcha_verify = true;
            this.g_recaptcha_response = response;
            this.verifyG2fa();
        },
        onExpired: function () {
            this.recaptcha_verified = false;
            this.is_login_pending = false;
        },
        onExpiredVerify: function () {
            this.recaptcha_verify = false;
            this.is_login_pending = false;
        },
        onExpiredVerifyG2fa: function () {
            this.recaptcha_verify = false;
            this.is_login_pending = false;
        },
        verify(e) {
            let form;
            if (e && e.target) {
                form = $(e.target);
            } else {
                form = $('#sms-verification-form');
            }

            form.validate({
                lang: 'fa',
                rules: {
                    verify_code: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                this.is_submitting_verify = false;
                return;
            }

            let params = {
                code: this.verify_code,
                phone: this.phone,
                device_id: localStorage.getItem('device_id')
            };

            if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

            let botId = this.$route.query.botId;

            this.is_login_pending = true;

            this.$store
                .dispatch('auth/verifyForLogin', params)
                .then(
                    (response) => {
                        if (botId) {
                            window.alert(
                                'فعال سازی ربات تلگرام با موفقیت انجام شد.'
                            );
                        }
                        this.is_login_pending = false;
                        this.finishLogin();
                    },
                    (error) => {
                        console.error('Verify request failed:', error);

                        // Handle specific captcha errors
                        if (
                            error.data &&
                            error.data.data &&
                            error.data.data['g-recaptcha-response']
                        ) {
                            console.error(
                                'Captcha validation failed on server'
                            );
                            this.error_message =
                                'Security verification failed. Please try again.';
                            this.resetCaptchaVerify();
                        } else {
                            // Handle other validation errors
                            if (error.data && error.data.data) {
                                form.validate().showErrors(error.data.data);
                            }
                            this.error_message = error.message;

                            if (error.errors && error.errors.code) {
                                for (
                                    let i = 0;
                                    i < error.errors.code.length;
                                    i++
                                ) {
                                    this.error_message = error.errors.code[i];
                                }
                            }
                        }

                        this.recaptcha_verified = false;
                    }
                )
                .finally(() => {
                    this.is_login_pending = false;
                    this.is_submitting_verify = false;
                });
        },
        login(e) {
            let form = $(e.target);
            let botId = this.$route.query.botId;

            form.validate({
                lang: 'fa',
                rules: {
                    password: {
                        required: true
                    },
                    outh_param: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                return;
            }

            if (!this.isCaptchaVerified()) {
                return;
            }

            let params = {
                remember: this.remember,
                outh_param: this.outh_param,
                device_id: localStorage.getItem('device_id'),
                password: this.password,
                verfy_url: this.$url('verify'),
                botId
            };

            if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

            this.is_login_pending = true;
            this.$store
                .dispatch('auth/login', params)
                .then(
                    (response) => {
                        this.is_login_pending = false;

                        if (!response.has_two_factor_auth) {
                            if (botId) {
                                window.alert(
                                    'فعال سازی ربات تلگرام با موفقیت انجام شد.'
                                );
                            }
                            this.finishLogin();
                            return true;
                        }

                        setTimeout(() => {
                            document.getElementById(
                                'google_authenticator_code'
                            ) &&
                                Inputmask(
                                    '9     9     9     9     9     9'
                                ).mask(
                                    document.getElementById(
                                        'google_authenticator_code'
                                    )
                                );
                        }, 100);

                        this.two_factor_type = response.two_factor_type;
                        this.has_two_factor_auth = true;
                        this.is_g2fa_active = response.is_g2fa_active;
                        this.phone = response.phone;

                        if (response.two_factor_type == TwoFactorType.SMS) {
                            this.toastr.success('کد تایید ارسال شد');
                            this.sendVerifyStatus;
                            this.startTimer();
                            this.listenForSmsOtp();
                        }
                    },
                    (error) => {
                        this.is_login_pending = false;
                        this.error_message = error.data.message;
                        if (error.data.status === 429) {
                            this.error_message = error.data.message;
                            this.sendVerifyStatus;
                            this.startTimer();
                        }

                        if (error.data.tag == 'passwordChangeRequired') {
                            // Redirect to the password change page
                            sessionStorage.setItem(
                                'passwordChangeMessage',
                                this.$t('auth.90_days_password_cycle')
                            );
                            this.$router.push({ path: '/forget-pass' });
                            return;
                        }

                        this.recaptcha_verified = false;
                        this.resetCaptcha();
                    }
                )
                .catch((error) => {});
        },
        verifyWithG2fa() {
            if (this.is_g2fa_active) {
                this.two_factor_type = TwoFactorType.GOOGLE_AUTHENTICATOR;

                setTimeout(() => {
                    document.getElementById('google_authenticator_code') &&
                        Inputmask('9     9     9     9     9     9').mask(
                            document.getElementById('google_authenticator_code')
                        );
                }, 100);

                return;
            }

            this.toastr.error('Google Authenticator برای شما فعال نمیباشد.');
        },
        verifyG2fa() {
            let form = $('#g2fa-form');
            let btn = $('#g2fa-btn');

            form.validate({
                ignore: '.ignore',
                rules: {
                    google_authenticator_code: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                return;
            }

            let params = {
                phone: this.phone,
                google_authenticator_code:
                    this.google_authenticator_code.replace(/\s+/g, ''),
                device_id: localStorage.getItem('device_id')
            };

            if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

            KTApp.progress(btn);

            this.is_login_pending = true;

            this.$store
                .dispatch('auth/verifyG2faForLogin', params)
                .then(
                    (response) => {
                        this.is_login_pending = false;
                        this.finishLogin();
                    },
                    (error) => {
                        form.validate().showErrors(error.data);
                        this.error_message = error.message;
                        if (error.errors && error.errors.code) {
                            for (let i = 0; i < error.errors.code.length; i++) {
                                this.error_message = error.errors.code[i];
                            }
                        }
                        this.resetCaptchaVerifyG2fa();
                    }
                )
                .finally(() => {
                    this.is_login_pending = false;
                    KTApp.unprogress(btn);
                });
        },
        sendVerify(e) {
            let btn = $(e.target);
            let form = $('.kt-form');

            let params = {
                phone: this.phone
            };

            KTApp.progress(btn);
            this.$store
                .dispatch('auth/sendVerify', params)
                .then((response) => {
                    this.two_factor_type = TwoFactorType.SMS;
                    this.toastr.success(response.message);
                    this.sendVerifyStatus;
                    this.startTimer();
                    this.timer = 180;
                    this.listenForSmsOtp();
                })
                .catch((response) => {
                    if (response.data) {
                        form.validate().showErrors(response.data);
                    }
                    this.showMsg($('.kt-form'), 'danger', response.message);
                })
                .finally(() => {
                    KTApp.unprogress(btn);
                });
        },
        // WebOTP: reads the code from an SMS ending in "@my.paystar.ir #<code>"
        // (Chrome on Android). iOS fills it via autocomplete="one-time-code".
        listenForSmsOtp() {
            if (!('OTPCredential' in window)) return;

            this.stopListeningForSmsOtp();
            const controller = new AbortController();
            this.otp_abort_controller = controller;

            navigator.credentials
                .get({ otp: { transport: ['sms'] }, signal: controller.signal })
                .then((otp) => {
                    if (!otp || !otp.code) return;
                    this.verify_code = otp.code;
                    if (!this.is_login_pending) {
                        this.$nextTick(() => this.onSubmitVerify());
                    }
                })
                .catch(() => {})
                .finally(() => {
                    if (this.otp_abort_controller === controller) {
                        this.otp_abort_controller = null;
                    }
                });
        },
        stopListeningForSmsOtp() {
            if (this.otp_abort_controller) {
                this.otp_abort_controller.abort();
                this.otp_abort_controller = null;
            }
        },
        startTimer() {
            this.interval = setInterval(this.countDown, 1000);
        },
        countDown() {
            var n = this.timer;
            if (!this.counter) {
                this.counter = true;
            } else if (n > 0) {
                n = n - 1;
                this.timer = n;
                let minute = parseInt(n % 60);
                let second = parseInt(n / 60);
                this.message2 = `ارسال مجدد کد${this.pad(second)}:${this.pad(
                    minute
                )} دیگر `;
                this.message3 = `درخواست ورود از طریق پیامک${this.pad(
                    second
                )}:${this.pad(minute)} دیگر `;
            } else {
                clearInterval(this.interval);
                this.counter = false;
                this.message2 = '';
            }
        },
        pad(d) {
            return d < 10 ? '0' + d.toString() : d.toString();
        },
        showMsg(form, type, message) {
            this.error_message = message;
        }
    },
    async created() {
        if (this.$route.params.token !== undefined) {
            localStorage.setItem('access_token', this.$route.params.token);
            localStorage.setItem('user', this.$route.params.user);
            Axios.defaults.headers.common['Authorization'] =
                'Bearer ' + this.$route.params.token;
            let route = this.$route.query.route;
            let shop = this.$route.query.shop;
            let slug = this.$route.query.slug;
            if (slug !== undefined) localStorage.setItem('shop_slug', slug);
            if (shop !== undefined) {
                localStorage.setItem('shop_name', 'paystar.shop');
            } else {
                localStorage.setItem('shop_name', 'pegen.ir');
            }
            if (route === undefined)
                return window.location.replace(MYPANEL_REFRENCE);
            window.location.replace(MYPANEL_REFRENCE + route);
        }
    },
    beforeDestroy() {
        this.stopListeningForSmsOtp();
    }
};
</script>

<style scoped>
#password_eye {
    width: fit-content;
    position: relative;
    cursor: pointer;
    width: 0;
    height: 0;
    top: 1em;
    right: 81%;
}
ul {
    list-style: none;
}

/* درگاه پرداخت — سیر ورود تا تسویه، همگام با مرحله جاری */
.login-paylane {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75%;
    margin: 26px auto 6px;
}
.paylane-node {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: transparent;
    border: 1px solid rgba(0, 190, 165, 0.35);
    color: #00bea5;
    opacity: 0.45;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    transition: background-color 0.4s ease, color 0.4s ease,
        border-color 0.4s ease, opacity 0.4s ease, box-shadow 0.4s ease;
}
.paylane-node.is-done {
    opacity: 1;
    background: rgba(0, 190, 165, 0.14);
    border-color: rgba(0, 190, 165, 0.55);
    color: #00bea5;
}
.paylane-node.is-active {
    opacity: 1;
    background: #00bea5;
    border-color: #00bea5;
    color: #fff;
    animation: paylane-pulse 2.2s ease-out infinite;
}
.paylane-link {
    flex: 1 1 auto;
    max-width: 60px;
    height: 2px;
    margin: 0 8px;
    border-top: 2px dashed rgba(0, 190, 165, 0.35);
    position: relative;
    overflow: visible;
    opacity: 0.45;
    transition: opacity 0.4s ease, border-color 0.4s ease, border-top-style
        0.4s;
}
.paylane-link.is-done {
    opacity: 1;
    border-top-style: solid;
    border-top-color: rgba(0, 190, 165, 0.6);
}
.paylane-link.is-running {
    opacity: 1;
}
.paylane-dot {
    display: none;
    position: absolute;
    top: -4px;
    right: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #00bea5;
}
.paylane-link.is-running .paylane-dot {
    display: block;
    animation: paylane-drift 2.4s linear infinite;
}
@keyframes paylane-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(0, 190, 165, 0.45);
    }
    70% {
        box-shadow: 0 0 0 12px rgba(0, 190, 165, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(0, 190, 165, 0);
    }
}
@keyframes paylane-drift {
    0% {
        right: 0;
        opacity: 0;
    }
    15% {
        opacity: 1;
    }
    85% {
        opacity: 1;
    }
    100% {
        right: calc(100% - 6px);
        opacity: 0;
    }
}
@media (max-width: 576px) {
    .login-paylane {
        width: 85%;
        margin-top: 22px;
    }
    .paylane-node {
        width: 38px;
        height: 38px;
    }
    .paylane-link {
        max-width: 40px;
        margin: 0 5px;
    }
}
@media (prefers-reduced-motion: reduce) {
    .paylane-node.is-active,
    .paylane-link.is-running .paylane-dot {
        animation: none;
    }
}
</style>
